import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { AuxiliarService } from '../../services/auxiliar.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-photo',
  standalone: false,
  templateUrl: './photo.component.html',
  styleUrl: './photo.component.scss'
})
export class PhotoComponent implements OnInit, OnChanges {
  @Input() editable: boolean = true;
  @Input() image: string;
  @Input() width: number = 200;

  @Output() imageReadyEvent = new EventEmitter<{ photo: string, blob: Blob }>();
  
  private blob: Blob;
  public croppedImageFinal: string;
  public croppedImageTemp: string = '';
  public imageChangedEvent: File | null = null;
  public showCropperModal: boolean;
  
  constructor(
    private auxiliarService: AuxiliarService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.croppedImageFinal = this.image;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['image'] && !changes['image'].firstChange) {
      this.croppedImageFinal = changes['image'].currentValue;
    }
  }

  public fileChangeEvent(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];
      this.imageChangedEvent = file;
      this.showCropperModal = true;
      // to be able to show same image again
      target.value = '';
    }
  }

  public imageCropped(event: ImageCroppedEvent) {
    if (event.blob) {
      this.blob = event.blob;
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result as string;
        this.croppedImageTemp = base64;
      };
      reader.readAsDataURL(event.blob);
    }
  }

  public openFileSelector(input: HTMLInputElement) {
    input.value = '';
    input.click();
  }

  public saveCroppedImage() {
    if (this.croppedImageTemp) {
      this.croppedImageFinal = this.croppedImageTemp;
      this.showCropperModal = false;
      this.imageReadyEvent.emit({ photo: this.croppedImageFinal, blob: this.blob });
    }
  }

  public cancel(): void {
    this.showCropperModal = false;
  }

  public imageLoaded(image: LoadedImage) {
    // show cropper
  }

  public cropperReady() {
    // cropper ready
  }

  public loadImageFailed() {
    // show message
    this.auxiliarService.toast(this.translate.instant('error.load-image'), 'error');
    this.showCropperModal = false;
  }
}
